import React, { useRef, useState, useEffect } from "react";
import { Button, Container, Row, Spinner } from "reactstrap";
import Wheel from "@uiw/react-color-wheel";
import { useDispatch, useSelector } from "react-redux";
import { updateColors } from "store/actions/authActions";
import { toast } from "react-toastify";

const PopUp = ({
  id,
  adminColor,
  customerColor,
  handleClose,
  color,
  setColor
}) => {
  const popupRef = useRef(null);
  const dispatch = useDispatch();
  const { restaurantMedia } = useSelector((state) => state.restaurant);
  const { user, colorLoading } = useSelector((state) => state.auth);
  const [currentColor, setCurrentColor] = useState(color);
  const [tempColor, setTempColor] = useState(color);

  const handleColorChange = (color) => {
    if (id === "admin") {
      dispatch({
        type: "RESTAURANT_MEDIA",
        payload: { ...restaurantMedia, adminColor: color.hex }
      });
    }

    setColor(color.hex);
    setCurrentColor(color.hex);
  };

  const handleUpdateColor = (event) => {
    event.preventDefault();

    let obj = {
      customerColor,
      adminColor
    };

    if (obj) {
      dispatch(updateColors(user?.restaurantID, obj))
        .then(() => {
          toast.success("Restaurant colors updated");
          handleClose();
        })
        .catch(() => {
          toast.error("Failed to update colors");
        });
    }
  };

  const handleCancelColor = (event) => {
    event?.preventDefault?.();

    dispatch({
      type: "RESTAURANT_MEDIA",
      payload: { ...restaurantMedia, adminColor: tempColor }
    });
    setColor(tempColor);
    setCurrentColor(tempColor);
    handleClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleCancelColor(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Container>
      <Row className="popup-box">
        <div ref={popupRef}>
          <Wheel color={currentColor} onChange={handleColorChange} />

          <div className="mt-3 d-flex justify-content-between align-item-center w-100 ">
            <Button
              size="sm"
              onClick={(event) => {
                handleUpdateColor(event);
              }}
              color="warning"
              disabled={colorLoading}
            >
              {colorLoading ? <Spinner size="sm" /> : "Update"}
            </Button>
            <Button
              size="sm"
              onClick={(event) => {
                handleCancelColor(event);
              }}
              color="primary"
            >
              Cancel
            </Button>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default PopUp;
